import React, { useRef } from "react";

import { loadTextureFile } from "../materials/TextureLoader";

export default function TextureUpload({ label, texture, type, onChange }) {
  const inputRef = useRef();

  async function handleFile(event) {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    try {
      const nextTexture = await loadTextureFile(file, type);

      onChange(nextTexture);
    } catch (error) {
      console.error(`Failed to load ${label}:`, error);
    }

    /*
     * Allows selecting the same file
     * again later.
     */
    event.target.value = "";
  }

  return (
    <div
      style={{
        marginBottom: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        <span
          style={{
            fontFamily: "monospace",
            fontSize: "10px",
            color: "#858d87",
          }}
        >
          {label}
        </span>

        <div
          style={{
            display: "flex",
            gap: "6px",
          }}
        >
          <button
            type="button"
            className="reconstruction-button"
            onClick={() => inputRef.current?.click()}
          >
            {texture ? "REPLACE" : "UPLOAD"}
          </button>

          {texture && (
            <button
              type="button"
              className="reconstruction-button"
              onClick={() => onChange(null)}
            >
              CLEAR
            </button>
          )}
        </div>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFile}
        style={{
          display: "none",
        }}
      />
    </div>
  );
}
